<template>
  <div class="record pb-5">
    <img src="../assets/images/recipient.png" class="w-full" alt="" @click="gobackRecord()">
    <div class="w-[80%] mx-auto mt-3">
      <div class="text-left font-bold">
        <p class="mb-3">獎品品名: <span class="ml-2">{{ reward.exchangeName }}</span></p>
        <p class="mb-3">兌換 I D: <span class="ml-2">{{ actId }}</span></p>
        <div class="flex items-center mb-3">
          <p class="text-nowrap">收件人*：</p><input type="text" :disabled="source == 'record' && !isEdit" v-model="recipient.name" class="p-1 w-full">
        </div>
        <div class="flex items-center mb-3">
          <p class="text-nowrap">連絡電話*：</p><input type="tell" :disabled="source == 'record' && !isEdit" v-model="recipient.phone" class="p-1 w-full">
        </div>
        <div class="flex items-start justify-start flex-col mb-3">
          <p class="text-nowrap">收件地址*：</p>
          <input type="text"  v-model="recipient.address" :disabled="source == 'record' && !isEdit" class="p-1 w-full">
        </div>
        <div class="flex items-center mb-3">
          <p class="text-nowrap mb-2">電子信箱*：</p><input type="email" :disabled="source == 'record' && !isEdit"  v-model="recipient.mail" class="p-1 w-full">
        </div>
        <p v-if="reward.type == 3">獎品價值超過新臺幣1,000元(含)以上者，需填報中獎領據，並回傳主辦單位 <a href="mailto:lohas-go@nasme.org.tw">lohas-go@nasme.org.tw</a>。</p>
        <div v-if="reward.type == 3" class="bg-[#40a79e] text-white text-sm rounded-full w-fit my-3 px-4 py-1"><a href="https://drive.google.com/file/d/1VcoLpdSo9TEFyHdleH3tETwbzJFno6Zs/view?usp=sharing" target="_blank">獎品簽收單下載</a></div>
        <div class="flex items-center justify-center text-white " v-if="source == 'record'">
          <button class="rounded-full bg-zinc-400 py-1 mr-4 w-1/3 cursor-pointer" @click="gobackRecord">返回</button>
          <button class="rounded-full bg-[#40a79e] py-1 w-1/3 cursor-pointer" v-if="!isEdit" @click="isEdit = true">編輯</button>
          <button class="rounded-full bg-[#40a79e] py-1 w-1/3 cursor-pointer" v-if="isEdit" @click="comfirm()">確認</button>
        </div>
        <div v-if="source == 'main'">
          <div @click="comfirm()" class="mt-5 bg-[#c27719] py-1 text-center text-xl font-bold w-full text-white rounded-full tracking-widest">確認送出</div>
          <div @click="closeMsgModel()" class="mt-5 bg-[#40a79e] py-1 text-center text-xl font-bold w-full text-white rounded-full tracking-widest">返回首頁</div>
        </div>
        <p v-if="msg !== ''" class="text-red-500 font-bold my-2 text-center">{{ msg }}</p>
      </div>
    </div>
    <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="msgModel">
      <div class="modal-content shadow p-5 text-[#868686]">
        <p class="my-3">{{ responseMsg }}</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-[#40a79e]  py-2 w-1/3 cursor-pointer" @click="closeMsgModel()">確認</button>
        </div>
      </div>
    </div>
    <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="showNoticeModel">
      <div class="modal-content shadow p-5">
        <p class="my-2 text-3xl font-bold text-[#40a79e]">寄送資料確認</p>
        <div class="text-left font-bold">
          <p class="mb-3">獎品品名: <span class="ml-2">{{ reward.exchangeName }}</span></p>
          <p class="mb-3">兌換 I D: <span class="ml-2">{{ actId }}</span></p>
          <p class="mb-3">收件人: <span class="ml-2">{{ recipient.name }}</span></p>
          <p class="mb-3">連絡電話: <span class="ml-2">{{ recipient.phone }}</span></p>
          <p class="mb-3">收件地址: <span class="ml-2">{{ recipient.address }}</span></p>
          <p class="mb-3">電子信箱: <span class="ml-2">{{ recipient.mail }}</span></p>
          <p class="my-3 text-center">提醒您填寫表單時請確認寄送資訊以繁體中文填寫無誤，若因寄送資訊填寫錯誤或無法判讀導致寄送失敗，恕無法重新補寄。</p>
        </div>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-zinc-400 py-1 shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] w-1/3 cursor-pointer mr-3" @click="showNoticeModel = false">返回編輯</button>
          <button class="rounded-full bg-[#40a79e] shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] py-1 w-1/3 cursor-pointer" @click="send()">確認</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CryptoJS from 'crypto-js'
// import { json } from 'express'
import axios from 'axios'

export default {
  name: 'successView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      isEdit: false,
      msgModel: false,
      responseMsg: '',
      showNoticeModel: false,
      reward: {
        exchangeName: '',
        type: ''
      },
      recipient: {
        name: '',
        phone: '',
        mail: '',
        address: ''
      },
      msg: '',
      source: '',
      encryptedBase64: '',
      encryptedString: '',
      key: '5334023153340231',
      decryptedWord: null,
      decryptedData: null,
      openId: '',
      actId: '',
      windowHeight: window.innerHeight
    }
  },
  created () {
    if (window.sessionStorage.getItem('history') === '0') {
      window.sessionStorage.setItem('history', '1')
    } else {
      this.$router.go(-1)
    }
    this.openId = this.$route.query.openId
    this.actId = this.$route.query.actId
    this.source = this.$route.query.source
    this.reward.type = this.$route.query.type
    this.reward.exchangeName = this.$route.query.exchangeName
    console.log('this.reward', this.reward)
    if (this.source === 'record') {
      // this.recipient = JSON.parse(this.$route.query.biko)
      this.recipient.name = JSON.parse(JSON.parse(this.$route.query.biko)).name || ''
      this.recipient.phone = JSON.parse(JSON.parse(this.$route.query.biko)).phone || ''
      this.recipient.mail = JSON.parse(JSON.parse(this.$route.query.biko)).mail || ''
      this.recipient.address = JSON.parse(JSON.parse(this.$route.query.biko)).address || ''
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    goHome () {
      this.$router.replace('/exchange')
    },
    handleResize () {
      this.windowHeight = window.innerHeight
    },
    // 加密
    encryptData (data) {
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      this.encryptedBase64 = encryptedBase64
    },
    edit () {

    },
    gobackRecord () {
      this.$router.push({ name: 'record', query: { recordType: '2' } })
    },
    comfirm () {
      if (Object.values(this.recipient).every(value => value !== '')) {
        this.msg = ''
        if (this.source === 'main') {
          this.showNoticeModel = true
        } else {
          this.send()
        }
      } else {
        this.msg = '*表示必填問題，請填寫完整資料'
      }
    },
    send () {
      this.isEdit = false
      const recipientInfo = {
        openId: this.openId,
        actId: this.actId,
        biko: '123'
      }
      // 將kn字串再加密
      this.encryptData(recipientInfo)
      axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/EditBiko?inf=${this.encryptedBase64}`
      }).then((response) => {
        this.responseMsg = response.data.message
        this.showNoticeModel = false
        this.msgModel = true
      })
    },
    closeMsgModel () {
      if (this.source === 'main') {
        this.$router.replace({ name: 'exchange' })
      } else {
        this.$router.replace({ name: 'record', query: { recordType: '2' } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
input{
  border-bottom: 1px solid #707070;
  outline: none;
}
.record{
  .modal{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-content{
      max-width: 450px;
      background: #ffffff;
      width: 90%;
      border-radius: 12px;
      margin: auto;
    }
    .notice{
      border: 2px solid #fcc02e;
    }
  }
}
</style>
